import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import AddLeadForm from "./AddLeadForm";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import AgentReportDateWise from "./agent-report/agentReportDateWise";
import CommonStructured from "../common-components/CommonStructured";

const CommonAddLeadbtns = ({
  userInfoData,
  isCustom,
  onReload,
  isAddBtn,
  isToggle,
  setIsToggle,
}) => {
  const navigate = useNavigate();

  const iniModValues = {
    isModOpen: false,
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onOpenModal = (name) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: name,
    }));
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer add-new-lead-form ${
            modValues.modName === "add-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : ""
          }`}
        >
          {modValues.modName === "add-lead" ? null : (
            <ModalHeadAndClose
              title={`${
                modValues.modName === "add-lead"
                  ? "Add New Lead"
                  : modValues.modName === "agent-report"
                  ? "Front Desk/Club Manager Reports"
                  : modValues.modName
              }`}
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "add-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => {
                onReload();
              }}
            />
          ) : modValues.modName === "agent-report" ? (
            <AgentReportDateWise userInfoData={userInfoData} />
          ) : null}
        </div>
      </Modal>

      {/* <div className="desktop-margin-top-50"></div> */}

      <CommonStructured
        pageHeading={"Lead and Follow-up Management"}
        isReload={onReload}
        createBtnTxt={isAddBtn ? "+ Add New Lead" : null}
        onClickCreateBtn={() => onOpenModal("add-lead")}
        // createBtnTxt1={isAddBtn ? "View Agent Report" : null}
        // onClickCreateBtn1={() => onOpenModal("agent-report")}
        onClickBackBtn={isCustom ? handleBack : null}
      />

      {/* <BackAddBtns
        isCustom={isCustom}
        addBtnTxt={"Add New Lead"}
        onClickAdd={() => onOpenModal("add-lead")}
        addBtnTxt1={"View Agent Report"}
        onClickAdd1={() => onOpenModal("agent-report")}
        onClickBack={isCustom ? handleBack : null}
        onClickReload={() => {
          onReload();
        }}
        isAddBtn={isAddBtn}
      /> */}
    </>
  );
};

export default CommonAddLeadbtns;
